import { setupWorker } from 'msw/browser';

import { handlers } from './handlers';

const worker = setupWorker(...handlers);

export function isDemoAccess() {
  return localStorage.getItem('demoAccess') === 'true';
}

export async function startDemoAccess() {
  await worker.start();
  localStorage.setItem('demoAccess', 'true');
}

export function stopDemoAccess() {
  localStorage.removeItem('demoAccess');
  worker.stop();
}
